var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',[_c('app-header')],1),_c('div',{staticClass:"layout container"},[_c('div',{attrs:{"id":"main"}},[_vm._t("default")],2)]),_c('app-footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }